import { Button, CircularProgress } from "@mui/material";
import { useFormik } from "formik";
import { useCallback } from "react";
import Flex from "@/components/Flex";
import HomeCareRosForm from "@/pages/app/admin/library/templates/home-care-ros/HomeCareRosForm";
import { RosTemplate } from "@/services";
import {
  SectionAccordion,
  useRegisterSectionSave,
} from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/readmission-f2f";
import { useRosPeSection } from "../hooks/use-ros-pe-section";
import { ROS_PE_SAVE_LABEL } from "../initial-f2f-constant";
import { LibraryTemplateDef } from "../initial-f2f-types";

export interface RosPeSectionProps {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  template: LibraryTemplateDef;
}

const RosPeSection = ({
  title,
  expanded,
  onToggle,
  template,
}: RosPeSectionProps) => {
  const { systems, isLoading, isSaving, save } = useRosPeSection(
    template.encounterTemplateType
  );

  const formik = useFormik<RosTemplate>({
    initialValues: {
      templateTypes: template.templateType,
      templateName: template.templateName,
      rosTemplateTypeSet: systems,
    },
    enableReinitialize: true,
    onSubmit: (values) => save(values.rosTemplateTypeSet ?? []),
  });
  const pendingSystems = formik.values.rosTemplateTypeSet;
  const flush = useCallback(
    () => save(pendingSystems ?? []),
    [save, pendingSystems]
  );
  useRegisterSectionSave(template.encounterTemplateType, formik.dirty, flush);

  return (
    <SectionAccordion
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      showCurrentVisit={false}
    >
      {isLoading ? (
        <Flex justifyContent="center" p={2}>
          <CircularProgress size={22} />
        </Flex>
      ) : (
        <HomeCareRosForm formik={formik} />
      )}
      <Flex justifyContent="flex-end">
        <Button
          variant="contained"
          disabled={!formik.dirty || isSaving}
          onClick={formik.submitForm}
        >
          {ROS_PE_SAVE_LABEL}
        </Button>
      </Flex>
    </SectionAccordion>
  );
};

export default RosPeSection;
